module.exports = __webpack_public_path__ + "assets/img/materials.ef568137.png";